import { useRef } from "react";

export const useDebounce = () => {
  const debounceSeed = useRef<NodeJS.Timeout | null>(null);
  const debounceFunction = useRef((func: any, timeout = 200) => {
    if (debounceSeed.current) {
      clearTimeout(debounceSeed.current);
      debounceSeed.current = null;
    }
    debounceSeed.current = setTimeout(() => {
      func();
    }, timeout);
  });
  return debounceFunction.current;
};
